import { useRecommendationSelection } from '../../../hooks/useRecommendationSelection';
import { Header } from './Header';
import { SelectControls } from './SelectControls';
import { MetricsDashboard } from './MetricsDashboard';
import { EmptyState } from './EmptyState';
import type { RecommendationsSectionProps } from './types';

export type { RecommendationsSectionProps } from './types';

export const RecommendationsSection: React.FC<RecommendationsSectionProps> = ({
  data,
  onNavigateToOverview,
}) => {
  const {
    selectedRecommendations,
    toggleSelection,
    toggleAll,
    isSelected,
    allSelected,
    noneSelected,
  } = useRecommendationSelection(data.recommendations);

  return (
    <div
      className="max-w-7xl mx-auto view-fade-in px-4 sm:px-6 lg:px-8"
      style={{ marginTop: '6rem' }}
    >
      <Header onNavigateToOverview={onNavigateToOverview} />

      <div className="max-w-7xl mx-auto">
        <SelectControls
          recommendations={data.recommendations}
          selectedCount={selectedRecommendations.length}
          allSelected={allSelected}
          noneSelected={noneSelected}
          isSelected={isSelected}
          toggleSelection={toggleSelection}
          toggleAll={toggleAll}
        />

        {!noneSelected && (
          <div className="mt-12 animate-fade-in">
            <MetricsDashboard selectedCount={selectedRecommendations.length} />
          </div>
        )}

        {noneSelected && <EmptyState />}
      </div>
    </div>
  );
};

export default RecommendationsSection;
